import Navbar from "../../components/feature/Navbar";
import Footer from "../../pages/home/components/Footer";

const refundContent = [
  {
    title: "1. General Policy",
    paragraphs: [
      "This Refund Policy outlines the conditions under which Nova Vertex LTD (\"Company\", \"we\", \"our\", or \"us\") may provide refunds for payments made for services offered through this website (the \"Site\").",
      "We aim to provide high-quality services and fair treatment to all users. Refunds are considered in accordance with the terms set out below."
    ]
  },
  {
    title: "2. Eligibility for Refund",
    paragraphs: [
      "Refunds may be granted under the following conditions:\nA payment was made directly through the Company (e.g., via the Site using a valid payment method)\nA verified issue occurred that materially affected the delivery of the service\nThe refund request is submitted within 14 days of the original payment date",
      "Refunds are not guaranteed and are assessed on a case-by-case basis.\nRefunds will generally not be granted in the following situations:\nChange of mind or general dissatisfaction\nFailure to use the service\nUser error or misunderstanding of the service\nIssues caused by third-party services or external factors beyond our control\nRequests submitted after the applicable refund period"
    ]
  },
  {
    title: "3. Refund Request Process",
    paragraphs: [
      "To request a refund, you must contact our support team:\nEmail: support@novavertextech.com\nPhone: +44 7520 663474",
      "Your request should include:\nFull name and contact details\nProof of payment (date, amount, transaction reference if available)\nDescription of the issue or reason for the request",
      "We may request additional information to verify your claim."
    ]
  },
  {
    title: "4. Review and Approval",
    paragraphs: [
      "All refund requests are reviewed individually.\nThe Company reserves the right to:\nApprove or decline a refund request\nRequest additional documentation\nDetermine whether the issue qualifies under this Policy"
    ]
  },
  {
    title: "5. Processing of Refunds",
    paragraphs: [
      "If a refund is approved:\nThe refund will be issued using the original payment method where possible\nProcessing time may take 5–14 business days, depending on the payment provider\nAny applicable fees or taxes may be included where required by law"
    ]
  },
  {
    title: "6. Cancellations",
    paragraphs: [
      "If the Company offers services that can be cancelled:\nCancellation prevents future charges (if applicable)\nCancellation does not automatically entitle the user to a refund\nRefunds remain subject to the conditions outlined in this Policy."
    ]
  },
  {
    title: "7. Limitation of Liability",
    paragraphs: [
      "The Company is not responsible for:\nIssues caused by user devices, software, or internet connectivity\nInterruptions caused by third-party services\nFactors outside the Company’s reasonable control"
    ]
  },
  {
    title: "8. Changes to this Policy",
    paragraphs: [
      "We reserve the right to modify this Refund Policy at any time.\nUpdated versions will be posted on this page with a revised effective date. Continued use of the Site constitutes acceptance of the updated Policy."
    ]
  },
  {
    title: "9. Contact Information",
    paragraphs: [
      "Nova Vertex LTD\nInternational House\n66 Lavender Hill\nLondon\nSW11 5RQ\nUnited Kingdom\nsupport@novavertextech.com\n+44 7520 663474"
    ]
  }
];

export default function RefundPage() {
  return (
    <div className="min-h-screen bg-nv-light flex flex-col">
      <div className="bg-nv-black">
        <Navbar />
      </div>

      <main className="flex-1">
        <section className="py-16 md:py-24 px-6 md:px-10 lg:px-16">
          <div className="max-w-3xl mx-auto">
            <a
              href="/"
              className="inline-flex items-center gap-2 text-nv-gray text-sm hover:text-nv-black transition-colors mb-8 group"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-arrow-left-line text-sm group-hover:-translate-x-0.5 transition-transform"></i>
              </span>
              Back to Main Page
            </a>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-light text-nv-black tracking-tight mb-6">
              Refund Policy
            </h1>
            <p className="text-nv-gray text-sm md:text-base mb-12 md:mb-16">
              Last updated: 4 May 2026
            </p>

            <div className="flex flex-col gap-10 md:gap-14">
              {refundContent.map((section) => (
                <div key={section.title}>
                  <h2 className="text-xl md:text-2xl font-medium text-nv-black mb-4 md:mb-5">
                    {section.title}
                  </h2>
                  <div className="flex flex-col gap-4">
                    {section.paragraphs.map((paragraph, idx) => (
                      <div
                        key={idx}
                        className="text-nv-gray text-sm md:text-base leading-relaxed whitespace-pre-line"
                      >
                        {paragraph}
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}